import { Picture as PictureType } from '@/@types/common'
import clsx from 'clsx'
import { MouseEvent } from 'react'
import Picture, { PictureProps } from '../Picture'
import styles from './ImageGridItem.module.css'

export type ImageGridItemProps = PictureProps & {
	data: PictureType
	onClick?: (e: MouseEvent<HTMLImageElement>) => void
}

export default function ImageGridItem({ data, onClick, className, ...props }: ImageGridItemProps) {
	return (
		<Picture
			className={clsx(styles.root, className)}
			isLivePhoto={!!data.livePhoto}
			data={data.livePhoto}
			isPreview
			src={data.smallPicUrl}
			height={data.height}
			width={data.width}
			onClick={(e: MouseEvent<HTMLImageElement>) => {
				e.stopPropagation()
				if (onClick) {
					onClick(e)
				}
			}}
			data-clickable-feedback={!!onClick}
			data-anonymous-gallery
			{...props}
		/>
	)
}
